import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map, find } from 'lodash';
import Validator from 'validatorjs';
import { NumericFormat } from 'react-number-format';

import {
  Form, Button, Modal, Icon, Message, Divider,
} from 'semantic-ui-react';
import NotificationSettingsRow from './NotificationSettingsRow';
import NotificationSettingsForm from './NotificationSettingsForm';

class SubscriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      email: null,
      firstName: '',
      lastName: '',
      cellPhone: '',
      userName: '',
      notificationSettings: [],
      errors: {},
      error: null,
    };
  }

  componentDidMount() {
    const { subscription } = this.props;
    if (!isEmpty(subscription)) {
      const {
        id,
        email,
        firstName,
        lastName,
        cellPhone,
        userName,
        notificationSettings,
      } = subscription;

      this.setState({
        id: parseInt(id, 10),
        email,
        firstName,
        lastName,
        cellPhone,
        userName,
        notificationSettings,
      });
    }
  }

  onChangeHandler = field => event => {
    const { value } = event.target;
    this.setState(prevState => ({ ...prevState, [field]: value }));
  };

  removeNotificationSettingHandler = field => () => {
    const { notificationSettings: currentSettings } = this.state;
    const newNotificationSettings = [...currentSettings];

    const index = newNotificationSettings.indexOf(
      find(newNotificationSettings, ['dealerNumber', field])
    );

    newNotificationSettings.splice(index, 1);
    this.setState(prevState => ({ ...prevState, notificationSettings: newNotificationSettings }));
  };

  onChangeEmailFrequencyHandler = field => (event, data) => {
    const { notificationSettings: currentSettings } = this.state;
    const newNotificationSettings = [...currentSettings];
    const notificationSetting = {

      ...find(newNotificationSettings, ['dealerNumber', field]),
    };
    const index = newNotificationSettings.indexOf(
      find(newNotificationSettings, ['dealerNumber', field])
    );
    notificationSetting.emailFrequency = data.value;
    newNotificationSettings[index] = notificationSetting;
    this.setState(prevState => ({ ...prevState, notificationSettings: newNotificationSettings }));
  };

  onAddNewSettingsHandler = values => {
    const { notificationSettings: currentSettings } = this.state;
    const newNotificationSettings = [...currentSettings];

    newNotificationSettings.push(values);
    this.setState(prevState => ({ ...prevState, notificationSettings: newNotificationSettings }));
  };

  handleSubmit = () => {
    const { onSubmitHandler } = this.props;
    const {
      id: stateId,
      email: stateEmail,
      firstName: stateFirstName,
      lastName: stateLastName,
      cellPhone: stateCellPhone,
      userName: stateUserName,
      notificationSettings: stateNotificationSettings,
    } = this.state;

    const validationRules = {
      email: 'required|email',
      cellPhone: 'required|telephone',
      firstName: 'required',
      lastName: 'required',
      userName: 'required',
    };

    Validator.register(
      'telephone',
      value => {
        // requirement parameter defaults to null
        return value.match(/[^\d{3}]\d{3}-\d{4}$/);
      },
      'The :attribute phone number is not in the format (XXX)XXX-XXXX.'
    );

    const notificationSettingsArray = [];
    map(stateNotificationSettings, notificationSetting => notificationSettingsArray.push({
      dealerNumber: notificationSetting.dealerNumber,
      emailFrequency: notificationSetting.emailFrequency,
    }));

    const validation = new Validator(this.state, validationRules);
    if (validation.fails()) {
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
      return false;
    } if (notificationSettingsArray.length === 0) {
      this.setState(prevState => ({
        ...prevState,
        ...validation.errors,
        error:
            "Please click the green + button to add notifications for this dealer and then click 'Create'",
      }));
      return false;
    }
    onSubmitHandler({
      id: parseInt(stateId, 10),
      email: stateEmail,
      firstName: stateFirstName,
      lastName: stateLastName,
      cellPhone: stateCellPhone,
      userName: stateUserName,
      notificationSettings: notificationSettingsArray,
    });
    this.setState(prevState => ({ ...prevState, ...validation.errors, error: null }));
    return true;
  };

  render() {
    const {
      isModalOpen, onCloseHandler, error, submitting,
    } = this.props;

    const {
      errors,
      notificationSettings,
      id,
      email,
      firstName,
      lastName,
      cellPhone,
      userName,
      error: stateError,
    } = this.state;

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Notification Settings</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            You can select how frequently you get notifications for each
            dealership on your DealShield account.
            <br />
            <br />
            <br />
            {(error || stateError) && (
              <Message negative>
                <p>{error || stateError}</p>
              </Message>
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.firstName)}>
                  <label htmlFor='firstName'>First Name</label>
                  <input
                    id='firstName'
                    name='firstName'
                    value={firstName}
                    onChange={this.onChangeHandler('firstName')}
                  />
                  {errors.firstName && <span>{errors.firstName}</span>}
                </Form.Field>
                <Form.Field required error={!isEmpty(errors.lastName)}>
                  <label htmlFor='lastName'>Last Name</label>
                  <input
                    id='lastName'
                    name='lastName'
                    value={lastName}
                    onChange={this.onChangeHandler('lastName')}
                  />
                  {errors.lastName && <span>{errors.lastName}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.cellPhone)}>
                  <label htmlFor='cellPhone'>Mobile Phone</label>
                  <NumericFormat
                    id='cellPhone'
                    format='(###) ###-####'
                    mask='_'
                    value={cellPhone}
                    onChange={this.onChangeHandler('cellPhone')}
                  />
                  {errors.cellPhone && <span>{errors.cellPhone}</span>}
                </Form.Field>
                <Form.Field required error={!isEmpty(errors.email)}>
                  <label htmlFor='email'>Email</label>
                  <input
                    id='email'
                    name='email'
                    value={email}
                    onChange={this.onChangeHandler('email')}
                  />
                  {errors.email && <span>{errors.email}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.userName)}>
                  <label htmlFor='userName'>User Name</label>
                  <input
                    id='userName'
                    name='userName'
                    value={userName}
                    onChange={this.onChangeHandler('userName')}
                  />
                  {errors.userName && <span>{errors.userName}</span>}
                </Form.Field>
                <Form.Field />
              </Form.Group>
              <br />
              <Divider />
              <br />
              {map(notificationSettings, notificationSetting => (
                <NotificationSettingsRow
                  key={notificationSetting.dealerNumber}
                  notificationSetting={notificationSetting}
                  onChangeEmailFrequencyHandler={this.onChangeEmailFrequencyHandler}
                  removeNotificationSettingHandler={
                    this.removeNotificationSettingHandler
                  }
                />
              ))}

              <br />
              <Divider />
              <br />
              <NotificationSettingsForm
                onSubmitHandler={this.onAddNewSettingsHandler}
                notificationSettings={notificationSettings}
              />
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting && !id && (
            <Button color='green' onClick={this.handleSubmit} inverted>
              <Icon name='checkmark' /> Create
            </Button>
          )}

          {!submitting && id && (
            <Button color='green' onClick={this.handleSubmit} inverted>
              <Icon name='checkmark' /> Update
            </Button>
          )}

          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SubscriptionForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  subscription: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    cellPhone: PropTypes.string,
    userName: PropTypes.string,
    notificationSettings: PropTypes.array,
  }),
};

SubscriptionForm.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: null,
  submitting: false,
  subscription: {},
};

export default SubscriptionForm;
